<template>
  <Card :thumbnail="$path('image.url', value)" class="shop-set-card">
    <template #default>
      <h2 class="shop-set-card__title">{{ value.name }}</h2>
      <div class="shop-set-card__description">
        <div
          class="shop-set-card__description-wrapper"
          :class="{ 'shop-set-card__description-wrapper--empty': !value.description }"
        >
          <span v-html="value.description || $t('noDescription')"></span>
          <ScrollIndicator :value="['top', 'bottom']" />
        </div>
      </div>
      <div class="shop-set-card__products">
        <label class="mb-1" style="display: block">{{ $t('productsThatArePartOfSet') }}:</label>
        <div class="shop-set-card__products-wrapper">
          <ProductCard
            v-for="(product, index) in products"
            :key="index"
            show-image
            :value="product"
          >
            <template #actions>
              <ButtonComponent
                :label="$t('readMore')"
                @click="$emit('open:modal', product)"
                style="margin-left: auto; font-size: 0.7em"
              />
            </template>
          </ProductCard>
          <ScrollIndicator :value="['top', 'bottom']" />
        </div>
      </div>
    </template>
    <template #footer>
      <div class="shop-set-card__total">
        <span class="shop-set-card__total-value">{{ total }}</span>
        <span class="shop-set-card__total-vat">{{ $t('includingVat') }}</span>
      </div>
      <ButtonComponent
        :label="$t('select')"
        :icon="['fal', 'angle-right']"
        theme="primary"
        @click="
          $emit(
            'select',
            products.map(p => p.id),
          )
        "
      />
    </template>
  </Card>
</template>

<script>
import { Currency } from '../utils'

import ScrollIndicator from '@kvass/scroll-indicator'
import Card from '@kvass/card'
import ProductCard from '../Product/Card'

export default {
  props: {
    value: Object,
    shop: Object,
    setsStats: Object,
  },
  computed: {
    total() {
      return Currency(
        this.products.reduce((res, cur) => {
          if (cur.isDefault) return res
          return res + cur.product.gross
        }, 0),
      )
    },
    products() {
      return this.shop.categories.reduce((productLinks, category) => {
        category.categories.forEach(subcategory => {
          subcategory.items
            .filter(i => (i.sets || []).includes(this.value.id))
            .forEach(link => productLinks.push(link))
        })

        return productLinks
      }, [])
    },
  },
  components: {
    Card,
    ScrollIndicator,
    ProductCard,
  },
}
</script>

<style lang="scss">
.shop-set-card {
  --kvass-card-spacing: 1.75rem;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr min-content;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    box-shadow: none;
    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
    border-radius: 0;
  }

  .kvass-card__header {
    grid-row-end: span 2;
    border-radius: var(--kvass-card-border-radius) 0 0 var(--kvass-card-border-radius);
    border-bottom: none;
  }

  .kvass-card__footer-content {
    justify-content: space-between;
  }

  .scroll-indicator__arrow {
    border: 1px solid #dedede;
    border-radius: 20px 0 0 20px;
    border-right: none;
    width: 30px;
    height: 30px;
  }

  &__description,
  &__products {
    position: relative;

    &-wrapper {
      max-height: 300px;
      overflow-y: auto;
    }
  }

  &__description {
    background-color: #f7f7f7;
    border-radius: var(--border-radius);
    padding: 1.5rem;
    margin-top: 1rem;

    &-wrapper {
      &--empty {
        opacity: 0.5;
      }

      & > span > *:first-child {
        margin-top: 0;

        p:first-child {
          margin-top: 0;
        }
      }
    }
  }

  &__products {
    margin-top: 2rem;

    &-wrapper {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .shop-product-card {
      width: auto;
    }
  }

  &__title {
    margin: 0;
  }

  &__total {
    & > * {
      display: block;
    }

    &-value {
      font-weight: bold;
      font-size: 1.2rem;
    }

    &-vat {
      opacity: 0.5;
    }
  }
}
</style>
